import { IQueryConditionHandler } from "./iquerycondition.handler";

import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';
import { QueryCondition } from '../../entity/querycondition';
import { HelpValue } from '../../entity/conditionvalue/helpvalue';

export class SmartHelpHandler implements IQueryConditionHandler{
    // convert(qc: QueryCondition) {
    //     const shv = (qc.value as HelpValue);
    //     if(Object.keys(shv).length === 0 || !shv.value || !shv.valueField){
    //         return [];
    //     }else{
    //         // return [{
    //         //     'FilterField' : qc.fieldCode,
    //         //     'Compare' : CompareType.Equal, //equal
    //         //     'Value' : (shv.value)[shv.valueField],
    //         //     'Relation' : RelationType.And,
    //         //     'Expresstype': ValueType.Value
    //         // }];
    //         return [{
    //             'FilterField' : qc.fieldCode,
    //             'Compare' : CompareType.Equal, //equal
    //             'Value' : HelpValue.getPropValues(shv.value, shv.valueField.split('.')),
    //             'Relation' : RelationType.And,
    //             'Expresstype': ValueType.Value
    //         }];
    //     }
    // }

    convert(qc: QueryCondition) {
        const shv = (qc.value as HelpValue);
        if(shv.value.length == 0 || !shv.valueField){
            return [];
        }else{
            const arr = [];
            shv.getOriginalValue().split(',').forEach(id => {
                id && arr.push({
                    'FilterField' : qc.fieldCode,
                    'Compare' : CompareType.Equal,
                    'Value' : id,
                    'Relation' : RelationType.Or,
                    'Expresstype':ValueType.Value
                });
            });
            if(arr.length > 0){
                arr[0]['Lbracket'] = '(';
                arr[arr.length -1]['Rbracket'] = ')';
                arr[arr.length -1]['Relation'] = RelationType.And;
                return arr;
            }else{
                return [];
            }
        }
    }
}